<template>
    <div></div>
</template>

<script>
export default {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$router.replace(from.path)
        })
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/reload/refresh.vue